module.exports = __webpack_public_path__ + "123352716b6df5cc7d06e6edb5f9554b.ttf";


//////////////////
// WEBPACK FOOTER
// ./application/font/SourceSansPro-Regular.ttf
// module id = 364
// module chunks = 0